<template>
  <el-dialog
      title="Thông tin cấu hình nhà trường mới"
      :visible.sync="dialogVisible"
      width="1300px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="2vh"
  >
    <div v-if="systemConfigSchoolData != null" v-loading="loading" class="wrapper-table">
      <!-- Search Filter Input -->
      <div style="margin-bottom: 12px; display: flex; align-items: center; justify-content: flex-end;">
        <span style="font-size: 14px; font-weight: bold; margin-right: 8px; color: #475569;">Tìm kiếm cấu hình:</span>
        <el-input
          v-model="searchQuery"
          placeholder="Nhập nội dung thiết lập cần tìm..."
          size="small"
          clearable
          style="width: 320px;"
          prefix-icon="el-icon-search"
        />
      </div>

      <el-table
          :data="configRows"
          border
          class="sk-table custom-attendance-table"
          style="width: 100%"
          :max-height="$tableMaxHeight"
          :loading="loading"
      >
        <el-table-column type="index" label="STT" width="55" align="center"/>
        <el-table-column label="Nội dung thiết lập" min-width="500">
          <template v-slot="{row}">
            <div class="wrapper-config-label">
              <span class="config-desc">{{ row.description }}</span>
              <el-tooltip v-if="row.tooltip != null"
                          :content="row.tooltip"
                          placement="top"
                          :open-delay="300"
                          effect="dark"
                          popper-class="config-tooltip-popper"
              >
                <i class="el-icon-question" style="color: #6a96d6;"/>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Thiết lập" width="380" align="center">
          <template v-slot="{row}">
            <!-- BOOLEAN -->
            <template v-if="row.type === 'boolean'">
              <el-radio-group v-model="getObj(row)[row.field]" :disabled="row.disabled">
                <el-radio :label="!row.invertLabel">{{ row.labelTrue || 'Có' }}</el-radio>
                <el-radio :label="!!row.invertLabel">{{ row.labelFalse || 'Không' }}</el-radio>
              </el-radio-group>
            </template>
            <!-- TIME -->
            <template v-else-if="row.type === 'time'">
              <el-time-picker style="width:280px" size="mini" :clearable="false"
                              value-format="HH:mm" format="HH:mm"
                              v-model="getObj(row)[row.field]" :disabled="row.disabled"
                              :picker-options="{selectableRange:'00:00:00 - 23:59:59'}" placeholder="Chọn"/>
            </template>
            <!-- INPUT -->
            <template v-else-if="row.type === 'input'">
              <el-input size="mini" style="width:280px" v-model="getObj(row)[row.field]"
                        :disabled="row.disabled" :placeholder="row.placeholder||'Nhập'" :maxlength="row.maxlength"/>
            </template>
            <!-- NUMBER -->
            <template v-else-if="row.type === 'number'">
              <el-input-number size="mini" v-model="getObj(row)[row.field]"
                               :disabled="row.computedDisabled ? row.computedDisabled(systemConfigSchoolData) : row.disabled"
                               :min="row.min" :max="row.max" :step="row.step||1"/>
              <span v-if="row.suffix" style="margin-left:10px">{{ row.suffix }}</span>
            </template>
            <!-- SELECT -->
            <template v-else-if="row.type === 'select'">
              <el-select v-model="getObj(row)[row.field]" :disabled="row.disabled"
                         :placeholder="row.placeholder||'Chọn'" style="width:250px">
                <el-option v-for="opt in row.options" :key="opt.value" :value="opt.value" :label="opt.label"/>
              </el-select>
            </template>
            <!-- CHECKBOX GROUP -->
            <template v-else-if="row.type === 'checkbox-group'">
              <el-checkbox v-for="cb in row.checkboxes" :key="cb.field"
                           v-model="getObj(row)[cb.field]" :disabled="row.disabled">{{ cb.label }}
              </el-checkbox>
            </template>
            <!-- SWITCH GROUP -->
            <template v-else-if="row.type === 'switch-group'">
              <div class="switch-group">
                <div v-for="(item,idx) in row.switches" :key="idx" class="switch-item">
                  <span>{{ item.label }}</span>
                  <el-switch v-model="getObj(row)[item.field]" :disabled="row.disabled"/>
                </div>
              </div>
            </template>
            <!-- MULTI BOOLEAN -->
            <template v-else-if="row.type === 'multi-boolean'">
              <div v-for="(sub,idx) in row.subFields" :key="idx" class="multi-boolean-row">
                <span class="multi-boolean-label">{{ sub.label }}</span>
                <el-radio-group v-model="getObj(row)[sub.field]" :disabled="row.disabled">
                  <el-radio :label="true">Có</el-radio>
                  <el-radio :label="false">Không</el-radio>
                </el-radio-group>
              </div>
            </template>
            <!-- INPUT + TIME COMBO -->
            <template v-else-if="row.type === 'input-time'">
              <div>
                <el-input size="mini" style="width:280px" v-model="getObj(row)[row.field]"
                          :placeholder="row.placeholder||'Nhập số ngày'"/>
              </div>
              <div style="margin-top:10px">
                <el-time-picker style="width:280px" size="mini" :clearable="false"
                                value-format="HH:mm" format="HH:mm" v-model="getObj(row)[row.timeField]"
                                :picker-options="{selectableRange:'00:00:00 - 23:59:59'}" placeholder="Chọn"/>
              </div>
            </template>
            <!-- LATE PICKUP -->
            <template v-else-if="row.type === 'late-pickup'">
              <div class="composite-config">
                <el-radio-group v-model="schoolConfig.statusBlock">
                  <el-radio :label="true">Block</el-radio>
                  <el-radio :label="false">Ngày</el-radio>
                </el-radio-group>
                <div style="margin-top:10px">
                  <span>Số phút: </span>
                  <el-input-number v-model="schoolConfig.blockLeaveKid" style="width:160px" :min="0" :step="1"
                                   size="mini"/>
                </div>
                <el-radio-group v-model="schoolConfig.statusUpDown" style="margin-top:10px">
                  <el-radio :label="true">Làm tròn lên</el-radio>
                  <el-radio :label="false">Làm tròn xuống</el-radio>
                </el-radio-group>
              </div>
            </template>
            <!-- HOME TAB ORDER -->
            <template v-else-if="row.type === 'home-tab-order'">
              <div class="home-tab-config">
                <table class="tab-order-table">
                  <tr>
                    <td v-for="tab in homeTabItems" :key="tab.field">{{ tab.label }}</td>
                  </tr>
                  <tr>
                    <td v-for="tab in homeTabItems" :key="'cb-'+tab.field">
                      <el-checkbox v-model="schoolConfig[tab.activeField]"
                                   :disabled="tab.activeField==='activeShowNews'"
                                   @change="(v)=>handleTabActiveChange(tab,v)"/>
                    </td>
                  </tr>
                  <tr>
                    <td v-for="tab in homeTabItems" :key="'sel-'+tab.field">
                      <el-select size="mini" style="width:55px" v-model="schoolConfig[tab.sttField]"
                                 :disabled="!schoolConfig[tab.activeField]"
                                 @change="(v)=>handleTabOrderChange(tab,v)">
                        <el-option v-for="n in activeTabCount" :key="n" :value="n" :label="String(n)"/>
                      </el-select>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
            <!-- TUITION PLUS -->
            <template v-else-if="row.type === 'tuition-plus'">
              <div class="composite-config">
                <div>Gửi thông báo hoá đơn mới?
                  <el-radio-group v-model="schoolConfig.statusOrderNew" style="margin-left:8px">
                    <el-radio :label="true">Có</el-radio>
                    <el-radio :label="false">Không</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top:8px">
                  Ngày bắt đầu:
                  <el-input-number size="small" v-model="schoolConfig.dateSendPlus" style="width:100px"/>
                  <span v-if="schoolConfig.sendRepeatPlus&&!schoolConfig.statusOrderNew" style="margin-left:10px">
                    Bước nhảy: <el-input-number size="small" v-model="schoolConfig.dateJumpPlus" style="width:100px"/>
                  </span>
                </div>
                <div v-if="!schoolConfig.statusOrderNew" style="margin-top:8px">Gửi lặp lại?
                  <el-radio-group v-model="schoolConfig.sendRepeatPlus" style="margin-left:8px">
                    <el-radio :label="true">Có</el-radio>
                    <el-radio :label="false">Không</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top:8px">
                  Hết hạn trước:
                  <el-input-number size="small" v-model="schoolConfig.datePlus" style="width:100px"/>
                  Ngày
                </div>
              </div>
            </template>
            <!-- TUITION PARENT -->
            <template v-else-if="row.type === 'tuition-parent'">
              <div class="composite-config">
                <div>Ngày bắt đầu:
                  <el-input-number size="small" v-model="schoolConfig.dateSendParent" style="width:100px"/>
                </div>
                <div style="margin-top:8px">
                  Bước nhảy:
                  <el-input-number size="small" v-model="schoolConfig.dateJumpParent" style="width:100px"/>
                  <span style="margin-left:10px">Tần suất: <el-input-number size="small"
                                                                            v-model="schoolConfig.dateFrequencyParent"
                                                                            style="width:100px"/></span>
                </div>
                <div style="margin-top:8px">
                  Hết hạn trước:
                  <el-input-number size="small" v-model="schoolConfig.dateParent" style="width:100px"/>
                  Ngày
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else-if="!loading" style="text-align:center;padding:40px 0;color:#909399">Không có dữ liệu</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog">
        <i class="el-icon-circle-close"/><span>Đóng</span>
      </el-button>
      <el-button type="success" size="medium" :loading="loadingButton" @click="submitForm">
        <i class="el-icon-circle-check"/><span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import SystemConfigService from "@/services/AdminService/SystemConfigService";

const HOME_TABS = [
  {label: "Tin tức", field: "news", activeField: "activeShowNews", sttField: "sttShowNews"},
  {label: "Facebook", field: "facebook", activeField: "activeShowFacebook", sttField: "sttShowFacebook"},
  {label: "Video", field: "video", activeField: "activeShowVideo", sttField: "sttShowVideo"},
  {label: "Website trường", field: "website", activeField: "activeShowWebsiteSchool", sttField: "sttShowWebsiteSchool"},
  {label: "Tiktok", field: "tiktok", activeField: "activeShowTiktok", sttField: "sttShowTiktok"},
  {label: "Onekids Page", field: "onekidsPage", activeField: "activeShowOneKidsPage", sttField: "sttShowOneKidsPage"},
];

const SCHEMA = [
  // // 1-7: Đánh giá & Album
  // { field:"album", type:"boolean", source:"school", invertLabel:true, description:"Có cần duyệt Album ảnh hay không?", tooltip:"Nếu chọn CÓ thì plus phải duyệt album ảnh trước khi hiển thị cho GV và phụ huynh." },
  // { field:"evaluate", type:"boolean", source:"school", invertLabel:true, description:"Có cần duyệt đánh giá nhận xét hay không?", tooltip:"Nếu chọn CÓ thì plus phải duyệt nhận xét trước khi gửi đến phụ huynh." },
  // { field:"editAproved", type:"boolean", source:"school", description:"Có cho phép sửa đánh giá khi đã duyệt hay không?", tooltip:"Nếu chọn CÓ thì được phép sửa đánh giá khi đã duyệt." },
  // { field:"evaluateDate", type:"boolean", source:"school", description:"Có hiển thị chức năng đánh giá ngày hay không?", tooltip:"Nếu chọn CÓ thì chức năng đánh giá ngày được hiển thị." },
  // { field:"evaluateWeek", type:"boolean", source:"school", description:"Có hiển thị chức năng đánh giá tuần hay không?", tooltip:"Nếu chọn CÓ thì chức năng đánh giá tuần được hiển thị." },
  // { field:"evaluateMonth", type:"boolean", source:"school", description:"Có hiển thị chức năng đánh giá tháng hay không?", tooltip:"Nếu chọn CÓ thì chức năng đánh giá tháng được hiển thị." },
  // { field:"evaluatePeriod", type:"boolean", source:"school", description:"Có hiển thị chức năng đánh giá định kỳ hay không?", tooltip:"Nếu chọn CÓ thì chức năng đánh giá định kỳ được hiển thị." },
  // // 8-12: Điểm danh đến/về
  {
    field: "timeArriveKid",
    type: "time",
    source: "school",
    description: "Thiết lập giờ đến quy định của Nhà trường đối với học sinh",
  },
  {
    field: "timePickupKid",
    type: "time",
    source: "school",
    description: "Thiết lập giờ về quy định của Nhà trường đối với học sinh",
  },
  {
    field: "approvedAttendanceArrive",
    type: "boolean",
    source: "school",
    description: "Có gửi thông báo điểm danh đến hay không?",
    tooltip: "Nếu chọn CÓ thì sẽ gửi thông báo khi học sinh điểm danh đến."
  },
  {
    field: "timeAttendanceArrive",
    type: "time",
    source: "school",
    description: "Giới hạn thời gian gửi điểm danh đến trước mấy giờ?",
    tooltip: "Sau thời gian này được xử lý là đến muộn."
  },
  {
    field: "approvedAttendanceLeave",
    type: "boolean",
    source: "school",
    description: "Có gửi thông báo điểm danh về hay không?",
    tooltip: "Nếu chọn CÓ thì sẽ gửi thông báo khi học sinh điểm danh về."
  },
  {
    field: "timeAttendanceLeave",
    type: "time",
    source: "school",
    description: "Giới hạn thời gian gửi điểm danh về trước mấy giờ?",
    tooltip: "Sau thời gian này sẽ xử lý là đón muộn/về muộn."
  },
  {
    field: "breakfastAuto",
    type: "boolean",
    source: "school",
    description: "Áp dụng tự động điền điểm danh ăn bữa sáng theo đi học?",
    tooltip: "Nếu chọn CÓ thì sẽ tự động điểm danh ăn bữa sáng khi học sinh điểm danh đi học"
  },

  {
    field: "mainMealAuto",
    type: "boolean",
    source: "school",
    description: "Áp dụng tự động điền điểm danh ăn bữa chính theo đi học?",
    tooltip: "Nếu chọn CÓ thì sẽ tự động điểm danh ăn bữa chính khi học sinh điểm danh đi học"
  },

  {
    field: "snackAuto",
    type: "boolean",
    source: "school",
    description: "Áp dụng tự động điền điểm danh ăn bữa phụ theo đi học?",
    tooltip: "Nếu chọn CÓ thì sẽ tự động điểm danh ăn bữa phụ khi học sinh điểm danh đi học"
  },

  {
    field: "dinnerAuto",
    type: "boolean",
    source: "school",
    description: "Áp dụng tự động điền điểm danh ăn bữa tối theo đi học?",
    tooltip: "Nếu chọn CÓ thì sẽ tự động điểm danh ăn bữa tối khi học sinh điểm danh đi học"
  },

  {
    field: "applicationForLeave",
    type: "boolean",
    source: "school",
    description: "Có cho phép Nhà trường điểm danh khi có đơn xin nghỉ chưa xác nhận hay không?",
    tooltip: "Nếu chọn CÓ thì Nhà trường sẽ được điểm danh cho học sinh khi có đơn xin nghỉ chưa xác nhận"
  },

  {
    field: "applicationForLeaveTeacher",
    type: "boolean",
    source: "school",
    description: "Có cho phép Giáo viên điểm danh khi có đơn xin nghỉ chưa xác nhận hay không?",
    tooltip: "Nếu chọn CÓ thì Giáo viên sẽ được điểm danh cho học sinh khi có đơn xin nghỉ chưa xác nhận"
  },
  // { field:"againAttendance", type:"input-time", source:"school", timeField:"timeAttendanceLimit", description:"Cho phép giáo viên điểm danh lại với học sinh mấy ngày trước?", tooltip:"Thời gian GV được phép điểm danh lại. Nếu 0 thì thêm thời gian giới hạn trong ngày.", placeholder:"Nhập số ngày" },
  // 13-14: Xin nghỉ
  {
    field: "dateAbsent",
    type: "input",
    source: "school",
    description: "Gửi đơn xin nghỉ phải trước ngày đầu tiên muốn nghỉ số ngày là?",
    tooltip: "Số ngày tối thiểu phụ huynh phải gửi đơn trước.",
    placeholder: "Nhập số ngày"
  },
  {
    field: "timeAbsent",
    type: "time",
    source: "school",
    description: "Thời gian xin nghỉ phải trước mấy giờ?",
    tooltip: "Thời gian tối đa trong ngày để nộp đơn xin nghỉ, sau giờ này đơn có thể không được duyệt cho ngày đó hoặc tính là nghỉ không phép"
  },
  // // 15-18: Lịch học
  // { field:"morningSaturday", type:"boolean", source:"school", description:"Mặc định có học sáng thứ 7 hàng tuần không?", tooltip:"Nếu CÓ thì mặc định có học sáng thứ 7." },
  // { field:"afternoonSaturday", type:"boolean", source:"school", description:"Mặc định có học chiều thứ 7 hàng tuần không?", tooltip:"Nếu CÓ thì mặc định có học chiều thứ 7." },
  // { field:"eveningSaturday", type:"boolean", source:"school", description:"Mặc định có học tối thứ 7 hàng tuần không?", tooltip:"Nếu CÓ thì mặc định có học tối thứ 7." },
  // { field:"sunday", type:"boolean", source:"school", description:"Mặc định có học chủ nhật hàng tuần không?", tooltip:"Nếu CÓ thì mặc định có học Chủ nhật." },
  // // 19-21: Điểm danh buổi
  // { field:"morningAttendanceArrive", type:"boolean", source:"school", description:"Hiển thị điểm danh đi học buổi sáng không?", tooltip:"Nếu CÓ thì hiển thị điểm danh buổi sáng." },
  // { field:"afternoonAttendanceArrive", type:"boolean", source:"school", description:"Hiển thị điểm danh đi học buổi chiều không?", tooltip:"Nếu CÓ thì hiển thị điểm danh buổi chiều." },
  // { field:"eveningAttendanceArrive", type:"boolean", source:"school", description:"Hiển thị điểm danh đi học buổi tối không?", tooltip:"Nếu CÓ thì hiển thị điểm danh buổi tối." },
  // // 22-27: Điểm danh ăn
  // { field:"morningEat", type:"boolean", source:"school", description:"Hiển thị điểm danh ăn bữa sáng không?", tooltip:"Nếu CÓ thì hiển thị điểm danh ăn bữa sáng." },
  // { field:"secondMorningEat", type:"boolean", source:"school", description:"Hiển thị điểm danh ăn bữa phụ sáng không?", tooltip:"Nếu CÓ thì hiển thị điểm danh ăn bữa phụ sáng." },
  // { field:"lunchEat", type:"boolean", source:"school", description:"Hiển thị điểm danh ăn bữa trưa không?", tooltip:"Nếu CÓ thì hiển thị điểm danh ăn bữa trưa." },
  // { field:"afternoonEat", type:"boolean", source:"school", description:"Hiển thị điểm danh ăn bữa chiều không?", tooltip:"Nếu CÓ thì hiển thị điểm danh ăn bữa chiều." },
  // { field:"secondAfternoonEat", type:"boolean", source:"school", description:"Hiển thị điểm danh ăn bữa phụ chiều không?", tooltip:"Nếu CÓ thì hiển thị điểm danh ăn bữa phụ chiều." },
  // { field:"eveningEat", type:"boolean", source:"school", description:"Hiển thị điểm danh ăn bữa tối không?", tooltip:"Nếu CÓ thì hiển thị điểm danh ăn bữa tối." },
  // // 28-30: Duyệt
  // { field:"appSendApproved", type:"boolean", source:"school", invertLabel:true, description:"Có cần duyệt các thông báo gửi đi hay không?", tooltip:"Nếu CÓ thì thông báo cần được Plus duyệt trước." },
  // { field:"approvedSchedule", type:"boolean", source:"school", description:"Có cần duyệt nội dung thời khóa biểu hay không?", tooltip:"Nếu CÓ thì TKB cần được duyệt." },
  // { field:"approvedMenu", type:"boolean", source:"school", description:"Có cần duyệt nội dung thực đơn hay không?", tooltip:"Nếu CÓ thì thực đơn cần được duyệt." },
  // // 31-38: Quyền riêng tư & Học phí
  // { field:"parentPhone", type:"boolean", source:"school", description:"Cho phép hiển thị SĐT Phụ huynh với App GV?", tooltip:"Nếu CÓ thì SĐT PH hiển thị trên App GV." },
  // { field:"parentInfo", type:"boolean", source:"school", description:"Cho phép GV xem thông tin chi tiết của PH?", tooltip:"Nếu CÓ thì GV được xem thông tin chi tiết PH." },
  // { field:"employeePhone", type:"boolean", source:"school", description:"Cho phép hiển thị SĐT GV với App PH?", tooltip:"Nếu CÓ thì SĐT GV hiển thị trên App PH." },
  // { field:"employeeInfo", type:"boolean", source:"school", description:"Cho phép PH xem thông tin chi tiết của GV?", tooltip:"Nếu CÓ thì PH được xem thông tin chi tiết GV." },
  // { field:"historyViewParent", type:"boolean", source:"school", description:"Cho phép PH xem lại lịch sử học khi đã chuyển trường?", tooltip:"Nếu CÓ thì PH xem lại lịch sử học của con." },
  // { field:"historyViewTeacher", type:"boolean", source:"school", description:"Cho phép NV xem lại lịch sử làm việc khi đã nghỉ?", tooltip:"Nếu CÓ thì NV được xem lại lịch sử làm việc." },
  // { field:"feesInfo", type:"boolean", source:"school", description:"GV có được xem chi tiết khoản thu của HS lớp mình?", tooltip:"Nếu CÓ thì GV được xem chi tiết khoản thu." },
  // { field:"feesNumber", type:"boolean", source:"school", description:"GV có được xem số tiền học phí của HS?", tooltip:"Nếu CÓ thì GV được xem số tiền học phí." },
  // // 39-40: Thời gian quy định
  // { field:"timeArriveKid", type:"time", source:"school", description:"Giờ đến quy định của Nhà trường với HS?", tooltip:"Giờ đến quy định; dùng để đánh giá sớm/muộn." },
  // { field:"timePickupKid", type:"time", source:"school", description:"Giờ về quy định của Nhà trường với HS?", tooltip:"Giờ về/đón quy định cho HS." },
  // // 41-43: Mẫu hệ thống
  // { field:"showEvaluateSys", type:"boolean", source:"school", description:"Hiển thị thêm mẫu nhận xét của hệ thống?", tooltip:"Nếu CÓ thì hiển thị mẫu nhận xét hệ thống cung cấp." },
  // { field:"showAttentendanceSys", type:"boolean", source:"school", description:"Hiển thị thêm mẫu báo đến, báo về của hệ thống?", tooltip:"Nếu CÓ thì hiển thị mẫu báo đến/về hệ thống." },
  // { field:"showWishSys", type:"boolean", source:"school", description:"Hiển thị thêm mẫu lời chúc của hệ thống?", tooltip:"Nếu CÓ thì hiển thị mẫu lời chúc hệ thống." },
  // // 44-45: Thời gian NV
  // { field:"timeArriveEmployee", type:"time", source:"school", description:"Giờ đi làm buổi sáng của NV?", tooltip:"Giờ đến làm việc buổi sáng của NV." },
  // { field:"timeLeaveEmployee", type:"time", source:"school", description:"Giờ về của NV Nhà trường?", tooltip:"Giờ về/kết thúc làm việc của NV." },
  // // 46-53: Phiếu thu/chi & Lương
  // { field:"receiptNote", type:"boolean", source:"school", description:"Có tự động duyệt các phiếu thu không?", tooltip:"Nếu CÓ thì phiếu thu tự động duyệt khi tạo." },
  // { field:"paymentNote", type:"boolean", source:"school", description:"Có tự động duyệt các phiếu chi không?", tooltip:"Nếu CÓ thì phiếu chi tự động duyệt khi tạo." },
  // { field:"autoBillSalaryEmployee", type:"boolean", source:"school", description:"Có sinh tự động hóa đơn công lương NV cho tháng tiếp theo?", tooltip:"Sinh tự động vào ngày đầu tháng." },
  // { field:"autoSignSalaryEmployee", type:"boolean", source:"school", description:"Có sinh tự động các khoản công lương cho NV theo mặc định?", tooltip:"Sinh tự động các khoản công lương mặc định." },
  // { field:"autoNextmonthSalaryDate", type:"number", source:"school", min:1, max:31, description:"Ngày sinh tự động khoản công lương cho Nhân sự?", tooltip:"Ngày của tháng (1-31) để sinh tự động.", computedDisabled:(d)=>!d.schoolConfigInSysResponse.autoSignSalaryEmployee },
  // { field:"autoApprovedSalary", type:"boolean", source:"school", description:"Có tự động duyệt các khoản lương hàng tháng?", tooltip:"Nếu CÓ thì tự động duyệt khoản lương." },
  // { field:"autoLockSalarySuccess", type:"boolean", source:"school", description:"Có tự động khóa khoản lương khi thanh toán đủ?", tooltip:"Nếu CÓ thì tự động khóa khi đã thanh toán đủ." },
  // { field:"autoShowBillOfMonth", type:"boolean", source:"school", description:"Có tự động hiển thị hóa đơn lương cả tháng?", tooltip:"Nếu CÓ thì tự động hiển thị hóa đơn khi sinh." },
  // // 54-62: Học phí HS
  // { field:"autoFeesApprovedKids", type:"boolean", source:"school", description:"Có sinh tự động hóa đơn học phí HS cho tháng tiếp theo?", tooltip:"Sinh tự động vào ngày đầu tháng." },
  // { field:"autoGenerateFeesKids", type:"boolean", source:"school", description:"Có sinh tự động các khoản thu HS theo khoản đã đăng ký?", tooltip:"Sinh tự động theo khoản đã đăng ký." },
  // { field:"autoNexMonthFeesDate", type:"number", source:"school", min:1, max:31, description:"Ngày sinh tự động khoản thu cho HS?", tooltip:"Ngày (1-31) để sinh tự động khoản thu.", computedDisabled:(d)=>!d.schoolConfigInSysResponse.autoGenerateFeesKids },
  // { field:"autoApprovedFeesMonthKids", type:"boolean", source:"school", description:"Có tự động duyệt khoản thu HS hàng tháng?", tooltip:"Nếu CÓ thì tự động duyệt khoản thu hàng tháng." },
  // { field:"autoLockFeesSuccessKids", type:"boolean", source:"school", description:"Có tự động khóa khoản thu khi PH thanh toán đủ?", tooltip:"Nếu CÓ thì tự động khóa khi thanh toán đủ." },
  // { field:"autoShowFeesMonth", type:"boolean", source:"school", description:"Có tự động hiển thị hóa đơn học phí cả tháng?", tooltip:"Nếu CÓ thì tự hiển thị cho PH khi sinh." },
  // { field:"autoShowFeesFutureKids", type:"boolean", source:"school", description:"Có hiển thị khoản thu dự kiến cho PH?", tooltip:"Nếu CÓ thì hiển thị khoản thu dự kiến cho PH." },
  // { field:"showWalletParent", type:"boolean", source:"school", description:"Có cho phép PH truy cập ví?", tooltip:"Nếu CÓ thì PH truy cập ví trong ứng dụng." },
  // { field:"autoShowFeesFutureKidsForTeacher", type:"boolean", source:"school", description:"Có hiển thị khoản thu dự kiến cho GV?", tooltip:"Nếu CÓ thì hiển thị khoản thu dự kiến cho GV." },
  // // 63-68: Quản lý chung
  // { field:"deleteStatus", type:"boolean", source:"school", description:"Hiển thị nút xóa Nhân sự, HS?", tooltip:"Nếu CÓ thì hiển thị nút xóa." },
  // { field:"verifyCode", type:"input", source:"school", maxlength:6, description:"Mã xử lý trùng tài khoản", tooltip:"Tối đa 6 ký tự." },
  // { field:"checkCompleteFeesStatus", type:"boolean", source:"school", description:"Cho phép ra trường khi chưa hoàn thành học phí?", tooltip:"Nếu CÓ thì cho phép ra trường/nghỉ học khi chưa hoàn thành." },
  // { field:"notifyWalletOutStatus", type:"boolean", source:"school", description:"Gửi thông báo khi Nhà trường rút tiền từ ví?", tooltip:"Nếu CÓ thì gửi thông báo khi rút tiền." },
  // { field:"showOnecamPlus", type:"boolean", source:"school", description:"Hiện OneCam Plus trong danh sách Camera?", tooltip:"Nếu CÓ thì hiển thị OneCam Plus." },
  // { field:"albumMaxNumber", type:"input", source:"school", description:"Số lượng ảnh tối đa khi đăng Album?", tooltip:"Số ảnh tối đa mỗi album.", placeholder:"Nhập số lượng" },
  // // 70-77: Tự động điền ĐD ăn & Xin nghỉ quá hạn
  // { field:"breakfastAuto", type:"boolean", source:"school", description:"Tự động điền ĐD ăn sáng theo đi học?", tooltip:"Nếu CÓ thì tự động điền ĐD ăn sáng theo trạng thái đi học." },
  // { field:"secondBreakfastAuto", type:"boolean", source:"school", description:"Tự động điền ĐD ăn phụ sáng theo đi học?", tooltip:"Nếu CÓ thì tự động điền ĐD ăn phụ sáng." },
  // { field:"lunchAuto", type:"boolean", source:"school", description:"Tự động điền ĐD ăn trưa theo đi học?", tooltip:"Nếu CÓ thì tự động điền ĐD ăn trưa." },
  // { field:"afternoonAuto", type:"boolean", source:"school", description:"Tự động điền ĐD ăn chiều theo đi học?", tooltip:"Nếu CÓ thì tự động điền ĐD ăn chiều." },
  // { field:"secondAfternoonAuto", type:"boolean", source:"school", description:"Tự động điền ĐD ăn phụ chiều theo đi học?", tooltip:"Nếu CÓ thì tự động điền ĐD ăn phụ chiều." },
  // { field:"dinnerAuto", type:"boolean", source:"school", description:"Tự động điền ĐD ăn tối theo đi học?", tooltip:"Nếu CÓ thì tự động điền ĐD ăn tối." },
  {
    field: "attendanceCreateLetter",
    type: "boolean",
    source: "school",
    description: "Tự động tạo điểm danh khi xin nghỉ quá hạn?",
    tooltip: "Nếu CÓ thì tự động tạo điểm danh khi xin nghỉ quá hạn."
  },
  {
    field: "absentYesNoLetter",
    type: "boolean",
    source: "school",
    description: "Trạng thái điểm danh mặc định khi xin nghỉ quá hạn?",
    tooltip: "Chọn Có phép/Không phép.",
    labelTrue: "Có phép",
    labelFalse: "Không phép"
  },
  {
    field: "forceVideoDownloadConfig",
    type: "boolean",
    source: "school",
    description: "Ép toàn hệ thống theo cấu hình tải video?",
    tooltip: "Nếu chọn Có, toàn hệ thống sẽ dùng trạng thái của thiết lập tự động tải video bên dưới."
  },
  {
    field: "autoDownloadVideo",
    type: "boolean",
    source: "school",
    description: "Có tự động tải video xuống để xem lâu dài không?",
    tooltip: "Trạng thái tự động tải video được áp dụng khi bật ép cấu hình."
  },
  // // 78-105: Cấu hình hệ thống (disabled)
  // { field:"timeSendCelebrate", type:"time", source:"sys", disabled:true, description:"Thời gian gửi lời chúc mừng mặc định?", tooltip:"Thời gian gửi lời chúc mặc định trong ngày." },
  // { field:"qualityPicture", type:"input", source:"sys", disabled:true, description:"Chất lượng ảnh theo %?", tooltip:"Chất lượng ảnh nén/giải nén theo %.", placeholder:"Nhập khoảng" },
  // { field:"widthPicture", type:"input", source:"sys", disabled:true, description:"Chất lượng ảnh theo kích thước?", tooltip:"Chất lượng ảnh theo chiều rộng pixel.", placeholder:"Nhập khoảng" },
  // { field:"showTitleSms", type:"boolean", source:"sys", disabled:true, description:"Chèn tiêu đề vào nội dung tin nhắn?", tooltip:"Nếu CÓ thì chèn tiêu đề mặc định vào SMS." },
  // { field:"titleContentSms", type:"input", source:"sys", disabled:true, description:"Nội dung tiêu đề mặc định trong SMS?", tooltip:"Chuỗi tiêu đề mặc định.", placeholder:"Nhập tiêu đề" },
  // { field:"appSendParent", type:"boolean", source:"sys", disabled:true, description:"Hiện PH đã đọc/chưa đọc với App GV/Plus?", tooltip:"Hiển thị trạng thái PH đã đọc." },
  // { field:"appSendTeacher", type:"boolean", source:"sys", disabled:true, description:"Hiện GV đã đọc/chưa đọc với App PH?", tooltip:"Hiển thị trạng thái GV đã đọc." },
  // { field:"numberRemindParent", type:"input", source:"sys", disabled:true, description:"Số lần nhắc lại với App PH?", tooltip:"Số lần nhắc tối đa.", placeholder:"Nhập số lần" },
  // { field:"jumpTimeParent", type:"input", source:"sys", disabled:true, description:"Khoảng thời gian nhắc App PH (phút)?", tooltip:"Phút giữa 2 lần nhắc.", placeholder:"Nhập số phút" },
  // { field:"numberRemindTeacher", type:"input", source:"sys", disabled:true, description:"Số lần nhắc lại với App GV?", tooltip:"Số lần nhắc tối đa.", placeholder:"Nhập số lần" },
  // { field:"jumpTimeTeacher", type:"input", source:"sys", disabled:true, description:"Khoảng thời gian nhắc App GV (phút)?", tooltip:"Phút giữa 2 lần nhắc.", placeholder:"Nhập số phút" },
  // { field:"numberRemindPlus", type:"input", source:"sys", disabled:true, description:"Số lần nhắc lại với App Plus?", tooltip:"Số lần nhắc tối đa.", placeholder:"Nhập số lần" },
  // { field:"jumpTimePlus", type:"input", source:"sys", disabled:true, description:"Khoảng thời gian nhắc App Plus (phút)?", tooltip:"Phút giữa 2 lần nhắc.", placeholder:"Nhập số phút" },
  // { field:"timeFrom", type:"time", source:"sys", disabled:true, description:"Thời gian bắt đầu nhắc lần đầu?", tooltip:"Thời gian bắt đầu trong ngày để nhắc." },
  // { field:"timeTo", type:"time", source:"sys", disabled:true, description:"Thời gian cuối cùng có thể nhắc?", tooltip:"Thời gian cuối cùng trong ngày có thể nhắc." },
  // { field:"numberOutSchool", type:"input", source:"sys", disabled:true, description:"Số ngày sau khi HS sang trường mới sẽ báo?", tooltip:"Số ngày quy định.", placeholder:"Nhập số ngày" },
  // { field:"numberNotify", type:"input", source:"sys", disabled:true, description:"Số lần gửi TB cho trường khi HS sang trường mới?", tooltip:"Số lần gửi thông báo.", placeholder:"Nhập số lần" },
  // { field:"jumpNumberOut", type:"input", source:"sys", disabled:true, description:"Khoảng thời gian gửi TB (ngày)?", tooltip:"Đơn vị: ngày/1 lần.", placeholder:"Nhập số ngày" },
  // { field:"deleteAccountStatus", type:"boolean", source:"sys", disabled:true, description:"Tự động xóa TK khi không còn đối tượng con?", tooltip:"Nếu CÓ thì tự động xóa TK." },
  // { field:"deleteAccountDate", type:"number", source:"sys", disabled:true, description:"Thời gian xóa tự động TK (ngày)?", tooltip:"Số ngày chờ trước khi xóa." },
  // { field:"cardNumber", type:"number", source:"sys", disabled:true, min:3, max:50, description:"Số thẻ nhận diện AI tối đa?", tooltip:"Số thẻ tối đa cho 1 đối tượng." },
  // { field:"fingerNumber", type:"number", source:"sys", disabled:true, min:3, max:10, description:"Số vân tay AI tối đa?", tooltip:"Số vân tay tối đa cho 1 đối tượng." },
  // { field:"sendFireBaseToPlus", type:"boolean", source:"sys", disabled:true, description:"Gửi nhận diện Smile HS qua Firebase cho Plus?", tooltip:"Gửi Firebase cho app Plus." },
  // { field:"sendFireBaseToPlusByTeacher", type:"boolean", source:"sys", disabled:true, description:"Gửi nhận diện Smile GV qua Firebase cho Plus?", tooltip:"Gửi Firebase GV cho Plus." },
  // { field:"sendFireBaseToTeacher", type:"boolean", source:"sys", disabled:true, description:"Gửi nhận diện Smile HS qua Firebase cho Teacher?", tooltip:"Gửi Firebase cho app Teacher." },
  // { field:"mobileRecognition", type:"switch-group", source:"sys", disabled:true, description:"Quản lý nhận diện mobile", tooltip:"Bật/tắt các tính năng nhận diện mobile.",
  //   switches:[{label:"Thêm mặt HS",field:"addFaceStudent"},{label:"Thêm mặt NV",field:"addFaceEmployee"},{label:"Thêm thẻ HS",field:"addCardStudent"},{label:"Thêm thẻ NV",field:"addCardEmployee"},{label:"Thêm vân tay HS",field:"addFingerStudent"},{label:"Thêm vân tay NV",field:"addFingerEmployee"},{label:"Xóa thẻ HS",field:"deleteCardStudent"},{label:"Xóa thẻ NV",field:"deleteCardEmployee"}] },
  // { field:"showOnekidsFace", type:"boolean", source:"sys", disabled:true, description:"Hiển thị Onekids Face trên Mobile?", tooltip:"Nếu CÓ thì hiển thị nhận diện Face." },
  // { field:"enableOnlinePayment", type:"boolean", source:"sys", disabled:true, description:"Cho phép thanh toán trực tuyến?", tooltip:"Nếu CÓ thì cho phép thanh toán online." },
  // // 106-137: Các cấu hình school tiếp
  // { field:"latePickup", type:"late-pickup", source:"school", description:"Thiết lập thời gian đón muộn", tooltip:"Block/Ngày, số phút, làm tròn lên/xuống." },
  // { field:"homeTabOrder", type:"home-tab-order", source:"school", description:"Cấu hình thứ tự hiển thị tin tức màn Home?", tooltip:"Cấu hình thứ tự nguồn nội dung trên Home." },
  // { field:"attendanceDuplicate", type:"boolean", source:"school", description:"Tự động xóa dữ liệu ĐD/nhận xét trùng?", tooltip:"Nếu CÓ thì tự động xóa dữ liệu trùng." },
  // { field:"statusBank", type:"boolean", source:"school", description:"Áp dụng nhiều TK ngân hàng cho 1 HS?", tooltip:"Nếu CÓ thì cho phép nhiều TK ngân hàng." },
  // { field:"tuitionPlus", type:"tuition-plus", source:"school", description:"Cấu hình gửi TB gói học phí cho Nhà trường (Plus)", tooltip:"Cấu hình TB gói học phí cho Plus." },
  // { field:"tuitionParent", type:"tuition-parent", source:"school", description:"Cấu hình gửi TB gói học phí cho PH (PHHS)", tooltip:"Cấu hình TB gói học phí cho PH." },
  // { field:"autoCancelTuition", type:"boolean", source:"school", description:"Tự động huỷ đăng kí gói học phí khi hết hạn?", tooltip:"Nếu CÓ thì tự động hủy khi hết hạn." },
  // { field:"autoAttendanceLeaveOnTime", type:"boolean", source:"school", description:"Tự động ĐD xin nghỉ đúng hạn?", tooltip:"Nếu CÓ thì tự động ĐD xin nghỉ đúng hạn." },
  // { field:"appLeave", type:"multi-boolean", source:"school", description:"Cho ĐD khi có đơn xin nghỉ chưa xác nhận?", tooltip:"Cho phép ĐD khi có đơn chưa xác nhận.",
  //   subFields:[{label:"Plus",field:"applicationForLeave"},{label:"Teacher",field:"applicationForLeaveTeacher"}] },
  // { field:"qrApprove", type:"multi-boolean", source:"school", description:"Tự động duyệt khi gửi ĐD bằng mã QR?", tooltip:"Tự động duyệt ĐD bằng QR.",
  //   subFields:[{label:"Teacher",field:"autoApproveRollCallByQrCode"},{label:"Parent",field:"autoApproveRollCallByQrCodeKid"}] },
  // { field:"takePicture", type:"checkbox-group", source:"school", description:"Chọn buổi tự động chụp ảnh ĐD đến bằng Onekids Face?", tooltip:"Chọn buổi chụp ảnh ĐD.",
  //   checkboxes:[{field:"takePictureMorning",label:"Sáng"},{field:"takePictureAfternoon",label:"Chiều"},{field:"takePictureEvening",label:"Tối"}] },
  // { field:"showOneCamOnOnekids", type:"boolean", source:"school", description:"Hiển thị link one-cam trên Onekids (Parent)?", tooltip:"Nếu CÓ thì hiển thị link One-Cam." },
  // { field:"timeCallCreateAlbum", type:"number", source:"school", suffix:"Giây", description:"Thời gian gọi lại xem album mới?", tooltip:"Giây để kiểm tra album mới." },
  // { field:"allowVoiceNotification", type:"boolean", source:"school", description:"Cho phép phát giọng nói khi có TB?", tooltip:"Nếu CÓ thì phát giọng nói khi có TB." },
  // { field:"numberVoiceNotification", type:"number", source:"school", suffix:"Lần", description:"Số lần phát giọng nói?", tooltip:"Số lần phát khi có TB." },
  // { field:"timeBetweenTwoTimesVoice", type:"number", source:"school", suffix:"Giây", description:"Thời gian giữa 2 lần phát?", tooltip:"Giây giữa 2 lần phát." },
  // { field:"appSuggestParent", type:"boolean", source:"school", description:"Hiện góp ý ẩn danh App PH?", tooltip:"Nếu CÓ thì hiện góp ý ẩn danh cho PH." },
  // { field:"appSuggestTeacher", type:"boolean", source:"school", description:"Hiện góp ý ẩn danh App GV?", tooltip:"Nếu CÓ thì hiện góp ý ẩn danh cho GV." },
  // { field:"showVersion", type:"boolean", source:"school", description:"Hiển thị thiết lập khác ở màn đăng nhập?", tooltip:"Nếu CÓ thì hiển thị thiết lập khác." },
  // { field:"commentsWithoutAttendance", type:"boolean", source:"school", description:"Cho phép nhận xét ngày HS không cần ĐD?", tooltip:"Nếu CÓ thì cho nhận xét mà không cần ĐD." },
  // { field:"openSoundAppPlus", type:"boolean", source:"school", description:"Bật âm thanh camera cho App Plus?", tooltip:"Nếu CÓ thì bật âm thanh camera." },
  // { field:"showTotalMoneyTuition", type:"boolean", source:"school", description:"Hiển thị tổng tiền đã đóng/còn phải đóng (HP Excel)?", tooltip:"Nếu CÓ thì hiển thị tổng tiền." },
  // { field:"attendanceVersionConfig", type:"select", source:"school", description:"Điểm danh version", tooltip:"Chọn phiên bản ĐD.", options:[{value:"VERSION_1",label:"VERSION 1"},{value:"VERSION_2",label:"VERSION 2"},{value:"VERSION_3",label:"VERSION 3"}] },
  // { field:"allowSelectionInterfaceVersion", type:"boolean", source:"school", description:"Cho phép lựa chọn phiên bản giao diện Trang chủ?", tooltip:"Nếu CÓ thì cho lựa chọn phiên bản." },
  // { field:"homepageInterfaceVersion", type:"select", source:"school", description:"Phiên bản giao diện Trang chủ", tooltip:"Phiên bản Trang chủ đang chọn.", options:[{value:"VERSION_1",label:"VERSION 1"},{value:"VERSION_2",label:"VERSION 2"}] },
  // { field:"showSettingAccount", type:"boolean", source:"school", description:"Hiển thị cài đặt ở màn tài khoản?", tooltip:"Nếu CÓ thì hiển thị cài đặt." },
  // { field:"showPhoneParentToParent", type:"boolean", source:"school", description:"Hiển thị SĐT PH với App PH?", tooltip:"Nếu CÓ thì hiển thị SĐT PH trên App PH." },
  // { field:"showPhoneTeacherToTeacher", type:"boolean", source:"school", description:"Hiển thị SĐT GV với App GV?", tooltip:"Nếu CÓ thì hiển thị SĐT GV trên App GV." },
  // { field:"maxSizeVideo", type:"number", source:"school", suffix:"(MB)", description:"Dung lượng tối đa 1 video?", tooltip:"Dung lượng tối đa cho video album/chat (MB)." },
  // { field:"maxSizeAlbumVideo", type:"number", source:"school", suffix:"(video)", description:"Số video tối đa 1 album?", tooltip:"Số video tối đa khi tải lên." },
  // { field:"numberOfStorageDays", type:"number", source:"school", suffix:"(ngày)", description:"Số ngày lưu trữ video trên server?", tooltip:"Hết hạn sẽ bị xóa khỏi server." },
  // { field:"approvedAlbumVideo", type:"boolean", source:"school", description:"Có cần duyệt Album(video)?", tooltip:"Nếu CÓ thì Plus cần duyệt Album video." },
  {
    field: "showZeroAmountDiscountedRevenue",
    type: "boolean",
    source: "school",
    description: "Hiển thị khoản thu có giảm giá > 0 và thành tiền = 0 trên Parent và Plus — Học phí V4?",
    tooltip: "Chọn Có để hiển thị khoản thu đang áp dụng giảm giá lớn hơn 0 và thành tiền bằng 0 trong chi tiết học phí V4 trên Parent và Plus. Giữ các cấp cha cần thiết để hiển thị khoản con đủ điều kiện. Mặc định Không."
  },
];

export default {
  name: "SystemConfigSchoolDialog",
  props: {
    dialogVisible: {type: Boolean, default: false},
  },
  watch: {
    dialogVisible(value) {
      if (value) {
        this.searchQuery = "";
      }
    }
  },
  data() {
    return {
      systemConfigSchoolData: null,
      loading: false,
      loadingButton: false,
      homeTabItems: HOME_TABS,
      sttSnapshot: {},
      searchQuery: "",
    };
  },
  computed: {
    schoolConfig() {
      return this.systemConfigSchoolData ? this.systemConfigSchoolData.schoolConfigInSysResponse : {};
    },
    sysConfig() {
      return this.systemConfigSchoolData ? this.systemConfigSchoolData.sysConfigResponse : {};
    },
    configRows() {
      if (!this.searchQuery) return SCHEMA;
      const q = this.searchQuery.toLowerCase().trim();
      return SCHEMA.filter(row => row.description && row.description.toLowerCase().includes(q));
    },
    activeTabCount() {
      if (!this.schoolConfig) return 6;
      return HOME_TABS.filter(t => this.schoolConfig[t.activeField]).length;
    },
  },
  methods: {
    getObj(row) {
      return row.source === "sys" ? this.sysConfig : this.schoolConfig;
    },
    getDataInitial(id) {
      this.loading = true;
      SystemConfigService.findSchoolConfigNewSystem(id)
          .then(resp => {
            this.systemConfigSchoolData = resp.data.data;
            this.$set(this.schoolConfig, "showZeroAmountDiscountedRevenue",
                this.schoolConfig.showZeroAmountDiscountedRevenue === true);
            this._saveSttSnapshot();
          })
          .catch(err => {
            console.log(err);
            this.systemConfigSchoolData = null;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // ─── HOME TAB GENERIC METHODS ──────────────────────────────────
    handleTabActiveChange(tab, value) {
      const cfg = this.schoolConfig;
      const currentStt = cfg[tab.sttField];
      if (!value) {
        HOME_TABS.forEach(t => {
          if (t.field !== tab.field && cfg[t.sttField] > currentStt) cfg[t.sttField]--;
        });
        cfg[tab.sttField] = HOME_TABS.length;
      } else {
        const activeCount = HOME_TABS.filter(t => t.field !== tab.field && cfg[t.activeField]).length;
        cfg[tab.sttField] = activeCount + 1;
      }
      this._saveSttSnapshot();
    },
    handleTabOrderChange(tab, newVal) {
      const cfg = this.schoolConfig;
      const oldVal = this._sttSnapshot[tab.field];
      HOME_TABS.forEach(t => {
        if (t.field !== tab.field && cfg[t.sttField] === newVal) {
          cfg[t.sttField] = oldVal || 1;
        }
      });
      cfg[tab.sttField] = newVal;
      this._saveSttSnapshot();
    },
    _saveSttSnapshot() {
      this._sttSnapshot = {};
      HOME_TABS.forEach(t => {
        this._sttSnapshot[t.field] = this.schoolConfig[t.sttField];
      });
    },
    _validateTabOrder() {
      const cfg = this.schoolConfig;
      const vals = HOME_TABS.filter(t => cfg[t.activeField]).map(t => cfg[t.sttField]);
      return new Set(vals).size === vals.length;
    },
    // ─── SUBMIT & CLOSE ────────────────────────────────────────────
    submitForm() {
      if (!this._validateTabOrder()) {
        this.$message({
          message: "Không được chọn thứ tự hiển thị tin tức màn Home giống nhau",
          type: "error",
          duration: 2000
        });
        return;
      }
      this.loadingButton = true;
      SystemConfigService.updateSchoolConfigNewSystem(this.systemConfigSchoolData)
          .then(() => {
            this.$message({message: "Cập nhật thành công", type: "success"});
            setTimeout(() => this.closeDialog(), 500);
          })
          .catch(err => {
            this.$message({message: err.response?.data?.message || "Có lỗi xảy ra", type: "error"});
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButton = false;
            }, 500);
          });
    },
    closeDialog() {
      this.$emit("dialog-close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}

.custom-attendance-table {
  border-radius: 10px !important;
  overflow: hidden;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 16px rgba(51, 65, 85, 0.04);

  /deep/ th.el-table__cell {
    background-color: #6a96d6 !important;
    color: #fff !important;
    font-weight: 600;
    padding: 8px 0;
    border-right: 1px solid #e2e8f0 !important;
    font-size: 13px;

    &.is-leaf {
      background-color: #6a96d6 !important;
      border-bottom: 1px solid #5a85c2 !important;
    }
  }

  /deep/ tr.el-table__row:hover > td.el-table__cell {
    background-color: #f0f7ff !important;
  }

  /deep/ td.el-table__cell {
    padding: 8px 0;
    border-bottom: 1px solid #f1f5f9;
    border-right: 1px solid #f1f5f9;
  }
}

.wrapper-config-label {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .config-desc {
    text-align: left;
    padding: 0 10px;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    display: block;
  }
}

.switch-group {
  padding: 8px;
  text-align: left;

  .switch-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
    font-size: 13px;
  }
}

.multi-boolean-row {
  display: flex;
  align-items: center;
  padding: 4px 0;

  .multi-boolean-label {
    width: 70px;
    text-align: left;
    font-size: 13px;
    color: #606266;
  }
}

.home-tab-config {
  overflow-x: auto;

  .tab-order-table {
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;

    td {
      padding: 4px 6px;
      text-align: center;
    }
  }
}

.composite-config {
  text-align: left;
  padding: 8px;
  font-size: 13px;
}

/deep/ .config-tooltip-popper {
  max-width: 480px;
  line-height: 1.5;
  white-space: normal;
}
</style>
